export const parsePteReadingExplanation = (value) => {
  const lines = String(value || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  if (!lines.length) return [];

  return lines.map((line) => {
    if (/^[-*]\s+/.test(line)) {
      return { type: "bullet", text: line.replace(/^[-*]\s+/, "") };
    }

    if (/^\d+[.)]\s+/.test(line)) {
      return { type: "number", text: line.replace(/^\d+[.)]\s+/, ""), number: line.match(/^\d+/)?.[0] };
    }

    if (/^[A-Z][A-Za-z\s()/-]{1,40}:/.test(line)) {
      const [label, ...rest] = line.split(":");
      return {
        type: rest.join(":").trim() ? "label" : "heading",
        label: label.trim(),
        text: rest.join(":").trim(),
      };
    }

    return { type: "paragraph", text: line };
  });
};
